<template>
  <div>
    <el-form
      :model="enterpriseFrom"
      :rules="rule_Form3"
      label-width="150px"
      ref="ruleForm3"
      class="demo-ruleForm"
      v-loading="contentLoading"
    >
      <el-form-item label="企业名称" prop="etpName">
        <el-input
          size="medium"
          v-model="enterpriseFrom.etpName"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="社会信用代码" prop="etpUscc">
        <el-input
          size="medium"
          v-model="enterpriseFrom.etpUscc"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="企业性质" prop="etpProperty">
        <maindata
          v-model="enterpriseFrom.etpProperty"
          dataKey="company-property"
          dataType="singleSelect"
        ></maindata>
      </el-form-item>
      <el-form-item label="所属行业" prop="etpIndustry">
        <maindata
          v-model="enterpriseFrom.etpIndustry"
          dataKey="company-industry"
          dataType="tree"
        ></maindata>
      </el-form-item>
      <el-form-item label="注册资本（万元）" prop="etpRegCapital">
        <el-input
          size="medium"
          v-model="enterpriseFrom.etpRegCapital"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="证件签发起止日期" prop="etpCertBeginDate">
        <el-date-picker
          style="width: 48%"
          v-model="enterpriseFrom.etpCertBeginDate"
          type="date"
          placeholder="选择开始日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-date-picker
          style="float: right; width: 48%"
          v-model="enterpriseFrom.etpCertEndDate"
          type="date"
          placeholder="选择结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="注册地址" prop="etpArea">
        <mainDataAddr
          :etpRegAddress="etpRA"
          @addr-sent="initAddr"
        ></mainDataAddr>
      </el-form-item>
      <el-form-item label="营业执照" prop="etpIdcard">
        <upLoadImg
          v-model="enterpriseFrom.etpIdcard"
          limit="1"
          @syncFileIds="setEtpIdcard"
        >
        </upLoadImg>
      </el-form-item>
    </el-form>
    <el-button
      style="width: 100%"
      size="medium"
      type="primary"
      @click="etpBtn('ruleForm3')"
      >保存</el-button
    >
  </div>
</template>

<script>
import { updateC, detailC } from '@/api/user/company'
import mainDataAddr from '@/components/MainData/mainDataAddr.vue'
import upLoadImg from '@/components/uploadImg/index.vue'
import maindata from '@/components/MainData/index.vue'
import { parseTime } from '@/utils/DateUtils'
export default {
  components: {
    mainDataAddr,
    maindata,
    upLoadImg
  },
  data() {
    return {
      contentLoading: false,
      enterpriseFrom: {
        etpName: '',
        etpUscc: '',
        etpProperty: '',
        etpIndustry: '',
        etpRegCapital: '',
        etpCertBeginDate: '',
        etpCertEndDate: '',
        etpIdcard: ''
      },
      etpRA: {},
      rule_Form3: {
        etpStreet: [
          { required: true, message: '注册地址不能为空', trigger: 'blur' }
        ],
        etpCertBeginDate: [
          {
            required: true,
            message: '证件签发起止日期不能为空',
            trigger: 'blur'
          }
        ],
        etpRegCapital: [
          { required: true, message: '注册资本不能为空', trigger: 'blur' }
        ],
        etpName: [
          { required: true, message: '企业名称不能为空', trigger: 'blur' }
        ],
        etpUscc: [
          {
            required: true,
            message: '统一社会信用代码不能为空',
            trigger: 'blur'
          }
        ],
        etpIndustry: [
          {
            required: true,
            message: '请选择所属行业',
            trigger: 'blur'
          }
        ],
        etpProperty: [
          {
            required: true,
            message: '请选择企业性质',
            trigger: 'blur'
          }
        ],
        etpIdcard: [
          {
            required: true,
            message: '请上传营业执照',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.getComanyInfo()
  },
  methods: {
    initAddr(originAddr) {
      this.enterpriseFrom.etpProvince = originAddr.province
      this.enterpriseFrom.etpCity = originAddr.city
      this.enterpriseFrom.etpArea = originAddr.area
      this.enterpriseFrom.etpStreet = originAddr.street
      this.enterpriseFrom.etpAddr = originAddr.addr
    },
    setEtpIdcard(v) {
      this.enterpriseFrom.etpIdcard = v
    },
    getComanyInfo() {
      this.contentLoading = true
      const data = {}
      detailC(data).then((res) => {
        if (res.success) {
          this.enterpriseFrom = res.result
          this.enterpriseFrom.etpCertBeginDate = parseTime(
            this.enterpriseFrom.etpCertBeginDate
          )
          this.enterpriseFrom.etpCertEndDate = parseTime(
            this.enterpriseFrom.etpCertEndDate
          )
          let tmpAddr = {}
          tmpAddr.province = this.enterpriseFrom.etpProvince
          tmpAddr.city = this.enterpriseFrom.etpCity
          tmpAddr.area = this.enterpriseFrom.etpArea
          tmpAddr.street = this.enterpriseFrom.etpStreet
          tmpAddr.addr = this.enterpriseFrom.etpAddr

          this.etpRA = tmpAddr
        }
        this.contentLoading = false
      })
    },
    etpBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 企业信息保存
          if (this.enterpriseFrom.etpCertBeginDate) {
            this.enterpriseFrom.etpCertBeginDate = Date.parse(
              this.enterpriseFrom.etpCertBeginDate
            )
          }
          if (this.enterpriseFrom.etpCertEndDate) {
            this.enterpriseFrom.etpCertEndDate = Date.parse(
              this.enterpriseFrom.etpCertEndDate
            )
          }
          updateC(this.enterpriseFrom).then((res) => {
            if (res.success) {
              this.$message.success('企业信息维护成功')
              location.reload()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
